// Central registry for all portal query keys.
//
// Add a new entry here whenever a new resource is introduced. The pattern:
//   <resource>: {
//     all: [<resource>] as const,                       // for invalidate-all
//     list: () => [...<resource>.all, 'list'] as const, // collection queries
//     detail: (id) => [...<resource>.all, 'detail', id] as const, // singletons
//   }
//
// Mutations should invalidate the broadest scope they touch (typically `all`),
// so list and detail views both refresh from a single invalidation call.
export const queryKeys = {
  appointments: {
    all: ['appointments'] as const,
    list: () => [...queryKeys.appointments.all, 'list'] as const,
    detail: (id: string) => [...queryKeys.appointments.all, 'detail', id] as const,
  }
};
